<bl-modal-content #content
  [title]="'送信する条件の確認'"
  [footerButtonType]="footerButtonType"
  [okButtonSetting]="okButtonSetting"
  [cancelButtonSetting]="cancelButtonSetting"
>
  <div body>
    <div class="description"><span class="icon-icon_alert notice_alert"></span>複数の友だちに一斉送信します。内容に間違いがないかご注意ください。</div>
    <div class="preview">
      <share-line-message-list-viewer
        [contentHorizontalAlignment]="'left'"
        [messageObjectStrings]="_previewMessages"
      ></share-line-message-list-viewer>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-confirm-modal/sns-send-message-confirm-modal.component.html